import { EntitlementService } from 'src/app/services/entitlement.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Ship } from '../../../Ship';
import { Router } from '@angular/router';
import { ShipService } from '../../../services/ship.service';

@Component({
  selector: 'app-ship-header-search',
  templateUrl: './ship-header-search.component.html',
  styleUrls: ['./ship-header-search.component.css']
})
export class ShipHeaderSearchComponent implements OnInit {
  @ViewChild('dropdownMenu', { static: false }) dropdownMenu: ElementRef;
  @ViewChild('searchField', { static: false }) searchField: ElementRef;
  @Input() shipSearchResultArray: Ship[];
  @Output() newShipSelected: EventEmitter<Ship> = new EventEmitter();
  menuOpen = false;

  constructor(
    private shipService: ShipService,
    private router: Router,
    private entitlementService: EntitlementService
  ) {}

  ngOnInit() {}

  shipSelected(shipData: Ship) {
    this.newShipSelected.emit(shipData);
    this.menuOpen = !this.menuOpen;
  }

  onInputClick() {
    this.menuOpen = !this.menuOpen;
  }

  startNewSearch() {
    this.router.navigateByUrl('/shipProfiles').then(() => {
      this.shipService.setPendingSearch(this.searchField.nativeElement.value);
    });
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
